/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Install_WebInputs */

const en_pc_online_cmp_install_web = /** @type {(inputs: Pc_Online_Cmp_Install_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None, runs in a tab`)
};

const zh_pc_online_cmp_install_web = /** @type {(inputs: Pc_Online_Cmp_Install_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需安装，在标签页中运行`)
};

/**
* | output |
* | --- |
* | "None, runs in a tab" |
*
* @param {Pc_Online_Cmp_Install_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_install_web = /** @type {((inputs?: Pc_Online_Cmp_Install_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Install_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_install_web(inputs)
	return zh_pc_online_cmp_install_web(inputs)
});
export { pc_online_cmp_install_web as "pc.online.cmp.install.web" }